export default {
  heroSlide1Title: "Egészségügyi gyorsítás a laborból az életbe",
  // heroSlide1Subtitle: "Vezető gyógyszeripari innováció 40+ év pszichotróp API és összetett generikus szakértelemmel",
  heroSlide2Title: "Globális elérés – Ügyfelek 80+ országban",
  // heroSlide2Subtitle: "Erős kapcsolatok kiépítése a világ vezető gyógyszeripari innovátoraival és generikus vállalataival",
  heroSlide3Title: "Alapanyagoktól a formulációkig: Egy partner. Teljes megbízhatóság",
  // heroSlide3Subtitle: "Végponttól végpontig terjedő gyógyszeripari megoldások integrált értéklánccal KSM, API és FDF területeken",
  heroSlide4Title: "6 globális létesítmény | 4 K&F központ | 1 globális gyógyszeripari platform",
  // heroSlide4Subtitle: "Világszínvonalú gyártási és kutatási infrastruktúra, amely az innovációt és a minőségi kiválóságot hajtja",
  heroSlide5Title: "Csoportvállalataink",
  // heroSlide5Subtitle: "Diverzifikált vállalati portfólió, amely együttműködve átfogó gyógyszeripari megoldásokat nyújt",
};

